/**
 * Created by fworld on 2019/9/20.
 */

import organization from "./organization";
import device from "./device/index";
import order from "./order";
import system from "./system";
export default {
    path: '/home',
    name: 'home',
    component: () => import('@/layout/main'),
    redirect: {name: 'delivery.index'},
    children: [
        {...organization},
        {...device},
        {...order},
        {...system},
    ]
}